"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    breadcrumbDefaultValue: function() {
        return breadcrumbDefaultValue;
    },
    BreadcrumbProvider: function() {
        return BreadcrumbProvider;
    },
    useBreadcrumbContext_unstable: function() {
        return useBreadcrumbContext_unstable;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const BreadcrumbContext = /*#__PURE__*/ _react.createContext(undefined);
const breadcrumbDefaultValue = {
    size: 'medium'
};
const BreadcrumbProvider = BreadcrumbContext.Provider;
const useBreadcrumbContext_unstable = ()=>{
    var _React_useContext;
    return (_React_useContext = _react.useContext(BreadcrumbContext)) !== null && _React_useContext !== void 0 ? _React_useContext : breadcrumbDefaultValue;
};
